<p class="a-text-h2 title">{{ 'common.re-login.title' | translate }}</p>

<adspt-login-form (loginSuccess)="$event ? success() : error()" />
